<!--详情背景组件 显示地址-->
<!-- -->
<template>
  <div class="div-b" v-if="addressInfo">
    <h5 class="h5" v-if="showBackText">商品寄回地址</h5>
    <van-row v-if="orderDetails.dispatchType != 5">
      <van-col span="3">
        <img class="img" src="@/assets/order/detail-location.png" alt />
      </van-col>
      <van-col :span="addAdressVisible ? 17 : 21">
        <div class="down">
          <div class="f16 mt-5">
            <span
              @click="showUpAdderssDetails"
            >{{addressInfo.userName || defaultInfo.userName}} &nbsp;&nbsp; {{addressInfo.mobile || defaultInfo.mobile}}</span>
            <div class="copy">
              <van-tag
                v-show="role== 'bees' && defaultInfo.userName"
                class="tag"
                plain
                type="warning"
                @click="copyFun(defaultInfo.userName + ',' + defaultInfo.mobile + ',' + defaultInfo.adress)"
              >复制</van-tag>
              <van-tag
                v-show="role== 'bees' && addressInfo.userName"
                class="tag"
                plain
                type="warning"
                @click="copyFun(addressInfo.userName + ',' + addressInfo.mobile + ',' + addressInfo.adress)"
              >复制</van-tag>
            </div>
          </div> 
          <div class="f12 col9">
            <span class="address">{{addressInfo.adress || defaultInfo.adress || '去添加'}}</span>
            <img
              v-if="this.orderDetails.addressModifyStatus==1"
              @click="changeAddressFun('update')"
              src="@/assets/image/arrow_icon@2x.png"
            />
          </div>
          <div class="f12 co19 center mr10">
            <span v-show="role== 'bees' && orderDetails.isFreeShippingCn" class="dtip">到付</span>
            <span
              class="span_tag"
              @click="changeAddressFun('update')"
              v-if="orderDetails.orderStatus=='WAIT_SEND'"
            >{{setShowInfo(orderDetails.addressModifyStatus)}}</span>

            <van-button
              style="margin-right: 5px;"
              v-show="role== 'bees' && (orderDetails.addressModifyStatus != 1) && orderDetails.orderStatus == 'WAIT_SEND' &&  (shadowBranchIf==1?false:true) "
              size="small"
              round
              normal
              hairline
              @click="directlyUpdateAddress"
              class="upData_btn"
            >
              直接修改地址
            </van-button>

            <van-button
              v-show="role== 'bees' && (orderDetails.addressModifyStatus != 2) && orderDetails.orderStatus == 'WAIT_SEND'&&(shadowBranchIf==1?false:true) "
              size="small"
              round
              normal
              hairline
              @click="upDateAddress"
              class="upData_btn"
            >
              {{
                orderDetails.addressModifyStatus == 0 ||
                orderDetails.addressModifyStatus == 3 ||
                orderDetails.addressModifyStatus == 4 ? "允许客户修改" : 
                  orderDetails.addressModifyStatus == 1 ? "撤销修改" : ''
              }}
            </van-button>
            


            <!-- <span
              v-show="role== 'bees' && orderDetails.addressModifyStatus!=2 && orderDetails.orderStatus=='WAIT_SEND' "
              class="upData_btn"
              @click="upDateAddress"
            >{{orderDetails.addressModifyStatus==0 || orderDetails.addressModifyStatus==3 || orderDetails.addressModifyStatus==4?"修改地址":orderDetails.addressModifyStatus==1?"撤销修改":''}}</span> -->
          </div>
        </div>
      </van-col>
      <van-col span="5" v-if="addAdressVisible">
        <div class="rig" @click="changeAddressFun('add')">
          <van-icon name="arrow" />
        </div>
      </van-col>
    </van-row>
    <div v-else class="div-mention">
      <div class="title">
        <div>门店自提</div>
        <div v-if="role == 'user'" class="navigation" @click="toNavigation">
          <span>导航</span>
          <van-icon class="arrow" name="arrow" />
        </div>
      </div>
      <div class="content">
        <div class="item">
          <div class="label">营业时间：</div>
          <div class="value" style="width: 270px;">{{ orderDetails.ownOpenTime }}</div>
        </div>
        <div class="item" style="padding-top: 2px;align-items: center;">
          <div v-if="role == 'user'" class="label" style="width: 114px; line-height: 20px;">联系电话：</div>
          <div v-if="role == 'bees'" class="label" style="width: 67px; line-height: 20px;">联系电话：</div>
          <div class="value" style="padding-top: 1px; line-height: 20px;">{{ orderDetails.ownPhone }}</div>
          <div v-if="role == 'user'" class="contact" @click="callPhone(orderDetails.ownPhone)">
            <van-icon name="phone"/>
            <span>联系门店</span>
          </div>
        </div>
        <div class="item">
          <div class="label">自提时间：</div>
          <div class="value" style="width: 270px;">
            <div class="ownDateTime">
              <div>
                <span style="margin-top: 2px">{{ orderDetails.ownStartMinuteTime }}-{{ orderDetails.ownEndMinuteTime }}</span>
                <span style="margin-left: 5px;margin-bottom: 2px;" v-if="orderDetails.ownDateTime">({{ orderDetails.ownDateTime }})</span>
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="label">自提规则：</div>
          <div class="value" style="width: 270px;" v-if="orderDetails.orderStatus=='WAIT_PAY' || orderDetails.orderStatus=='WAIT_SEND'">
            待店铺确认有货，发送短信后，可
            <span style="color: #ED3939;">{{ orderDetails.ownDay }}天内</span>
            凭提货码在提货时间内提货。
            <span style="color: #F8A651;">超过该时间门店可能无货，如需自提请提前联系门店确认是否有货。</span>
          </div>
          <div class="value" style="width: 270px;" v-else>
            请在即日起至
            <span style="color: #ED3939;">{{ orderDetails.endOwnDateTime }}</span>
            凭提货码在提货时间内提货。
            <span style="color: #F8A651;">超过该时间门店可能无货，如需自提请提前联系门店确认是否有货。</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show">
      <addressModal :value.sync="show" type="bees" :addressId="addressId" />
    </div>
  </div>
</template>
<script>
import http from "@/utils/axios";
import Util from "@/utils/common";
import addressModal from "@/views/beeorder/components/addressDetails";
// import { Toast } from "vant";
export default {
  props: {
    addressInfo: {
      type: Object,
      default: () => {
        return {};
      },
      required: false,
    },
    orderDetails: {
      type: Object,
      default: () => {
        return {};
      },
    },
    addAdressVisible: {
      type: Boolean,
      default: false,
      required: false,
    },
    showBackText: {
      type: Boolean,
      default: false,
      required: false,
    },
    role: {
      type: String,
      default: "user",
      required: false,
    },
    subId: {
      type: [String, Number],
      default: 0,
    },
    shadowBranchIf:{
      default:'0'
    }
  },
  data() {
    return {
      defaultInfo: {
        id: "",
        adress: "",
        userName: "",
        mobile: "",
      },
      show: false,
      isMention: false,
      navigationShow: false
    };
  },
  methods: {
    /**
     * 联系门店
     */
    callPhone(phone) {
      Util.callPhoneFun(phone)
    },
    /**
     * 导航
     */
    toNavigation() {
      let obj = {
        tm: 4000105,
        tp: {
          address: this.orderDetails.shopName,
          longitude: this.orderDetails.ilongitude,
          latitude: this.orderDetails.ilatitude
        }
      }
      Util.nativeMethod(obj)
    },
    onCancel() {},
    showUpAdderssDetails() {
      if (this.orderDetails.addressModifyStatus == 2) {
        this.show = !this.show;
      }
    },
    changeAddressFun(item) {
      if (item == "add") {
        this.$router.push({
          name: "myaddress",
          query: { quickOrder: "1" },
        });
      } else {
        if (this.orderDetails.addressModifyStatus == 1) {
          this.$router.push({
            name: "myaddress",
            query: { quickOrder: "1", subId: this.$route.query.subId },
          });
        }
      }
    },
    getAddressList() {
      http({
        url: "base/user/address/findDefault",
        method: "post",
        parmes: {},
      }).then((rps) => {
        this.defaultInfo.adress = rps.data.areaName + rps.data.addressDetail;
        this.defaultInfo.userName = rps.data.userName;
        this.defaultInfo.mobile = rps.data.mobile;
        this.defaultInfo.id = rps.data.id;
        //orderStatus == "WAIT_PAY" && this.getFrightPrice(element.id);
      });
    },
    copyFun(str) {
      Util.copyText(str);
    },
    setShowInfo(item) {
      let info = "";
      if (this.role == "bees") {
        switch (item) {
          case 1:
            info = "待客户修改地址";
            break;
          case 2:
            info = "已修改完成";
            break;
          case 3:
            info = "修改超时";
            break;
          case 4:
            info = "撤销修改";
            break;
          default:
            break;
        }
      } else {
        switch (item) {
          case 1:
            info = "待修改地址";
            break;
          case 2:
            info = "已修改完成";
            break;
          default:
            break;
        }
      }
      return info
    },
    directlyUpdateAddress() {
      let title = "直接修改地址";
      let message = "1、直接修改地址，不影响用户原地址，修改后地址只作用于当前订单；<br> 2、如修改后地址，运费增加，可根据实际情况，通过一笔新的快速订单补运费差价；<br>3、如修改后地址，运费减少，可告知客户在收货后，申请运费退款";
      this.$dialog.alert({
        title,
        message,
        showCancelButton: true,
        allowHtml: true,
        confirmButtonColor: "#F8A651",
        beforeClose: (action, done) => {
          if (action == "confirm") {
            let formData = {
              userId: this.orderDetails.userId,
              userName: this.orderDetails.receiverName,
              mobile: this.orderDetails.receiverPhone,
              addressDetail: this.orderDetails.receiverAddress,
            }
            this.$router.push({
              name: "editShippingAddress",
              query: {
                formData,
                subOrderId: this.subId || this.$route.query.subId,
                
              },
            });
            done();
          } else {
            done();
          }
        },
      });
    },
    upDateAddress() {
      let title = "允许修改地址";
      let message =
        "1、如修改后地址，运费增加，可根据实际情况，通过一笔新的快速订单补运费差价；<br> 2、如修改后地址，运费减少，可告知客户在收货后，申请运费退款";
      if ( this.orderDetails.addressModifyStatus && this.orderDetails.addressModifyStatus == 1) {
        title = "提示";
        message = "确定撤销修改地址吗？";
      }
      this.$dialog.alert({
        title,
        message,
        showCancelButton: true,
        allowHtml: true,
        confirmButtonColor: "#F8A651",
        beforeClose: (action, done) => {
          if (action == "confirm") {
            this.http({
              url: "/order/appOrder/addressModifyStatus",
              method: "post",
              parmes: {
                subOrderId: this.subId || this.$route.query.subId,
                updateStatus:
                  this.orderDetails.addressModifyStatus &&
                  this.orderDetails.addressModifyStatus == 1
                    ? 2
                    : 1,
              },
            }).then(() => {
              done();
              this.$emit("updateData", true);
            });
          } else {
            done();
          }
        },
      });
    },
  },
  created() {
    //this.getAddressList();
  },
  components: { addressModal },
};
</script>
<style lang="less" scoped rel="stylesheet/less">

.div-b {
  font-size: 0.4rem;
  border-radius: 0.15rem;
  background-color: #fff;
  // padding: 0.3rem 0.3rem 0.3rem 0.25rem;
  padding: 30px 35px 20px 10px;
  text-align: center;
  .div-mention {
    text-align: left;
    padding: 0 0 0 32px;
    
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 26px;
      font-weight: 500;
      color: #333333;
      .navigation {
        display: flex;
        align-items: center;
        font-size: 24px;
        font-weight: 500;
        color: #529CF9;
        .arrow {
          margin-left: 4px;
          color: #a6a6a6;
        }
      }
    }
    .content {
      font-size: 24px;
      color: #999999;
      .item {
        display: flex;
        margin-top: 18px;
        .label {
          width: 150px;
        }
        .value {
          width: 440px;
          .ownDateTime {
            height: 100%;
            display: flex;
            align-items: center;
          }
        }
        .contact {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 240px;
          height: 45px;
          line-height: 45px;
          text-align: center;
          border-radius: 36px;
          font-size: 20px;
          color: #999;
          border-color: #999999;
          padding: 0;
          border: 1px solid #999999;
          .van-icon {
            font-size: 28px;
          }
          >span {
            font-size: 20px;
            color: #999999;
            margin: 0 12px 0 5px;
          }
        }
      }
    }
  }
  .img {
    width: 40px;
    height: 40px;
  }
  .down {
    text-align: left;
    .f16 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 26px;
      font-weight: bold;
      word-break: break-all;
      .copy {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 80px;
      }
      /deep/ .tag {
        display: flex;
        align-items: center;
        justify-content: center;
        // width: 60px;
        // height: 30px;
         padding: 4px 10px;
        font-size: 20px;
        border-radius: 6px;
        // font-size: 20px;
        color: #F8A651;
        // margin-left: 20px;
      }
    }
    .mr10 {
      margin-top: 10px;
    }
    .f12 {
      font-size: 0.28rem;
      clear: both;
      .dtip {
        float: left;
        padding: 0 5px;
        border-radius: 6px;
        border: 2px solid #ed3939;
        font-size: 20px;
        color: #ed3939;
        text-align: center;
      }
      .span_tag {
        float: left;
        font-size: 24px;
        color: #ed3939;
        margin-left: 10px;
      }
    }
  }
  .rig {
    text-align: right;
    height: 1.35rem;
    line-height: 1.35rem;
  }
  .h5 {
    font-size: 26px;
    text-align: left;
    margin-left: 40px;
    margin-bottom: 30px;
    color: #333333;
  }
}
.mt-5 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}
.col9 {
  display: flex;
  justify-content: space-between;
  // align-items: center;
  color: #999999;
  .address {
    font-size: 24px;
  }
  span {
    display: inline-block;
    white-space: wrap;
    max-width: 450px;
  }

  img {
    width: 40px;
    height: 40px;
  }
}
.center {
  text-align: right;
}
.upData_btn {
  color: #333333;
  font-size: 24px;
  border-color:#999 ;
  border-radius: 32px;
  width: 200px;
  height: 60px;
  line-height: 60px;
  display: inline-block;
  text-align: center;

}
</style>